// Mock data for Agentic Atoms website - Enhanced Version

export const companyInfo = {
  name: "Agentic Atoms",
  logo: "/logo.png",
  address: {
    street: "5830 E 2nd St, Ste 7000 #30038",
    city: "Casper",
    state: "Wyoming",
    zip: "82609",
    country: "US"
  },
  fullAddress: "5830 E 2nd St, Ste 7000 #30038, Casper, Wyoming 82609 US",
  email: "connect@agenticatoms.com",
  phone: "+1-227-241-6372"
};

export const heroData = {
  title: "We Don't Just Talk AI.",
  titleLine2: "We Make It Work.",
  subtitle: "Transform your business with intelligent automation, custom AI apps, and workflow solutions that cut costs and supercharge productivity.",
  ctaText: "Explore Our Services",
  secondaryCta: "See Our Work",
  heroImage: "https://customer-assets.emergentagent.com/job_f1b7d916-bd37-4d28-868c-95bc2ecece40/artifacts/rjqlhgva_Black%20Friday%20Email%20Header%20%20%284%29.png"
};

export const aboutData = {
  title: "About Agentic Atoms",
  sectionTitle: "Our Approach",
  description: "Agentic Atoms is committed to revolutionizing businesses with AI-driven strategies that eliminate inefficiencies and drive rapid growth. We specialize in building custom AI applications, automating complex workflows, and creating high-performance e-commerce solutions. Our mission is to enable organizations to leverage the power of AI, achieving smarter results without increasing their workforce.",
  image: "https://images.unsplash.com/photo-1531973576160-7125cd663d86?w=600&auto=format&fit=crop&q=80",
  stats: [
    { value: "AI", label: "Powered Solutions" },
    { value: "24/7", label: "Automation Ready" },
    { value: "100%", label: "Commitment" }
  ]
};

export const productsData = {
  title: "Our Solutions",
  subtitle: "Powerful AI tools and custom applications designed for modern businesses.",
  products: [
    {
      id: 1,
      name: "Custom AI Apps",
      tagline: "Intelligent applications built for your needs.",
      description: "We build highly functional, AI-powered applications tailored to your specific business requirements. From concept to deployment.",
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&auto=format&fit=crop&q=80",
      features: ["AI-Powered", "Custom Built", "Scalable"],
      gradient: "from-gray-100 to-gray-200",
      benefits: [
        "Streamline manual processes with intelligent automation",
        "Get data-driven insights for better decision making",
        "Build solutions tailored to your unique business needs",
        "Seamlessly integrate with your existing systems"
      ]
    },
    {
      id: 2,
      name: "Workflow Automation",
      tagline: "Save 30% of your time.",
      description: "Automate repetitive tasks, streamline ordering systems, and connect your entire tech stack with intelligent workflow automation.",
      image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&auto=format&fit=crop&q=80",
      features: ["Smart Workflows", "API Connections", "Zero Manual Work"],
      gradient: "from-gray-50 to-gray-100",
      benefits: [
        "Free up your team to focus on high-value work",
        "Reduce errors in repetitive processes",
        "Connect all your tools and apps seamlessly",
        "Scale operations efficiently as you grow"
      ]
    },
    {
      id: 3,
      name: "E-Commerce Solutions",
      tagline: "Sell smarter, not harder.",
      description: "High-performance e-commerce websites built with AI-powered recommendations, automated inventory, and conversion optimization.",
      image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=600&auto=format&fit=crop&q=80",
      features: ["AI Recommendations", "Auto Inventory", "High Converting"],
      gradient: "from-gray-100 to-gray-50",
      benefits: [
        "Enhance customer experience with smart recommendations",
        "Automate inventory management and restocking",
        "Optimize your checkout flow for better conversions",
        "Create personalized shopping experiences"
      ]
    },
    {
      id: 4,
      name: "AI Sales & Marketing",
      tagline: "Campaigns that convert.",
      description: "Automated sales agents, marketing campaigns, and customer engagement tools powered by advanced AI and machine learning.",
      image: "https://images.unsplash.com/photo-1533750349088-cd871a92f312?w=600&auto=format&fit=crop&q=80",
      features: ["AI Sales Agents", "Auto Campaigns", "Lead Scoring"],
      gradient: "from-gray-50 to-gray-100",
      benefits: [
        "Qualify leads automatically with AI scoring",
        "Engage prospects around the clock",
        "Personalize campaigns for better engagement",
        "Optimize marketing spend with data insights"
      ]
    }
  ]
};

export const servicesData = {
  title: "What We Build",
  subtitle: "End-to-end AI solutions that transform how businesses operate, sell, and grow.",
  services: [
    {
      id: 1,
      title: "Custom AI Applications",
      description: "Bespoke AI-powered applications designed from the ground up. We turn your ideas into fully functional software using cutting-edge AI technology.",
      icon: "app",
      highlights: ["Mobile & Web Apps", "AI Integration", "Custom Dashboards"],
      benefits: "Accelerate decision-making and reduce operational bottlenecks with intelligent, purpose-built applications."
    },
    {
      id: 2,
      title: "Workflow Automation",
      description: "Automate your entire business workflow. From order processing to customer support, we connect and automate every touchpoint.",
      icon: "workflow",
      highlights: ["Order Streamlining", "CSR Automation", "Process Integration"],
      benefits: "Free up valuable time by automating repetitive tasks, allowing your team to focus on strategic work."
    },
    {
      id: 3,
      title: "Sales & Marketing Automation",
      description: "AI-powered sales agents, automated marketing campaigns, lead scoring, and customer journey optimization that runs 24/7.",
      icon: "sales",
      highlights: ["AI Sales Agents", "Campaign Automation", "Lead Generation"],
      benefits: "Improve lead quality and engagement with intelligent automation that works around the clock."
    },
    {
      id: 4,
      title: "E-Commerce & Websites",
      description: "High-converting e-commerce platforms and stunning websites built with AI. Automated inventory, smart recommendations, and seamless UX.",
      icon: "ecommerce",
      highlights: ["Shopify & Custom", "AI-Powered UX", "Auto Inventory"],
      benefits: "Create engaging shopping experiences with smart recommendations and streamlined operations."
    },
    {
      id: 5,
      title: "Customer Service AI",
      description: "Intelligent chatbots, automated support systems, and AI-driven customer service solutions that handle inquiries around the clock.",
      icon: "support",
      highlights: ["24/7 AI Support", "Smart Routing", "Sentiment Analysis"],
      benefits: "Reduce support costs by 60% while improving customer satisfaction scores by 30%."
    },
    {
      id: 6,
      title: "Business Intelligence",
      description: "Transform raw data into actionable insights. Custom dashboards, predictive analytics, and AI-driven reporting for smarter decisions.",
      icon: "analytics",
      highlights: ["Custom Dashboards", "Predictive Models", "Real-time Analytics"],
      benefits: "Data-driven companies make decisions 5x faster and identify revenue opportunities 40% sooner."
    }
  ]
};

export const automationFeatures = [
  {
    id: 1,
    title: "Order Processing",
    description: "Automate order intake, processing, and fulfillment workflows",
    icon: "package"
  },
  {
    id: 2,
    title: "Customer Support",
    description: "AI-powered CSR that handles queries and escalations",
    icon: "headphones"
  },
  {
    id: 3,
    title: "Sales Pipeline",
    description: "Automated lead scoring, follow-ups, and deal tracking",
    icon: "trending"
  },
  {
    id: 4,
    title: "Marketing Campaigns",
    description: "Scheduled campaigns, A/B testing, and performance tracking",
    icon: "megaphone"
  },
  {
    id: 5,
    title: "Inventory Management",
    description: "Real-time stock tracking with auto-reorder triggers",
    icon: "boxes"
  },
  {
    id: 6,
    title: "Reporting & Analytics",
    description: "Automated reports delivered to your inbox daily",
    icon: "chart"
  }
];

export const whyChooseData = {
  title: "Why teams pick us.",
  subtitle: "Production AI, shipped fast, owned by you.",
  features: [
    {
      id: 1,
      title: "Rapid Delivery",
      description: "Idea to live system in weeks — not months."
    },
    {
      id: 2,
      title: "Lower Costs",
      description: "Clients average 40% lower operating costs after deployment."
    },
    {
      id: 3,
      title: "24/7 Operations",
      description: "Systems that answer, qualify, and convert around the clock."
    },
    {
      id: 4,
      title: "Scales With You",
      description: "Built to grow from local business to enterprise without rebuilds."
    }
  ]
};

export const contactData = {
  title: "Tell us what to build.",
  subtitle: "Share the problem. We'll show you what's possible.",
  address: companyInfo.fullAddress
};

// Pages data for internal pages
export const pagesData = {
  careers: {
    title: "Careers at Agentic Atoms",
    subtitle: "Join our team of innovators",
    message: "We're not currently hiring, but we're always looking for exceptional talent.",
    noOpenings: true,
    noOpeningsMessage: "No open positions at this time. Check back soon—we're growing fast and new opportunities may open up. In the meantime, feel free to connect with us on LinkedIn to stay updated.",
    contactNote: "Interested in future opportunities? Send your resume to connect@agenticatoms.com"
  },
  resources: {
    title: "Resources",
    subtitle: "Learn, grow, and stay ahead with our insights",
    sections: [
      {
        title: "Blog",
        description: "Latest insights on AI, automation, and business transformation",
        items: [
          { title: "How AI is Revolutionizing Local Business Operations", date: "Coming Soon" },
          { title: "5 Workflow Automations Every E-Commerce Store Needs", date: "Coming Soon" },
          { title: "The ROI of Custom AI Applications: A Case Study", date: "Coming Soon" }
        ]
      },
      {
        title: "Case Studies",
        description: "Real results from real businesses",
        items: [
          { title: "How a Retail Company Saved 40% on Operations", date: "Coming Soon" },
          { title: "Scaling Customer Support with AI: A Success Story", date: "Coming Soon" },
          { title: "From Manual to Automated: A Manufacturing Transformation", date: "Coming Soon" }
        ]
      },
      {
        title: "Documentation",
        description: "Technical guides and API references",
        items: [
          { title: "Getting Started with Workflow Automation", date: "Coming Soon" },
          { title: "AI Integration Best Practices", date: "Coming Soon" },
          { title: "API Documentation & Developer Guide", date: "Coming Soon" }
        ]
      },
      {
        title: "Support",
        description: "Help when you need it",
        items: [
          { title: "FAQ - Frequently Asked Questions", date: "Available" },
          { title: "Contact Support Team", date: "Available" },
          { title: "Schedule a Consultation", date: "Available" }
        ]
      }
    ]
  }
};

export const footerData = {
  tagline: "Production AI for local businesses.",
  address: companyInfo.fullAddress,
  links: {
    'Company': ['About Us', 'Careers', 'Contact'],
    'Resources': ['Blog', 'Case Studies', 'Documentation', 'Support']
  }
};
